import React, { useContext } from "react";
import { MouseContext } from "../../contexts/Mouse";
import {
  StyledHeroContacts,
  StyledHeroLogo,
  StyledTitle,
  StyledContent,
  StyledOffices,
  StyledForm,
} from "./styles.js";

import dynamic from "next/dynamic";

const Widget = dynamic(() =>
  import("@typeform/embed-react").then((mod) => mod.Widget)
);

import { AnimateSplitFadeIn, AnimateFadeIn, WrapperLink, Cta } from "../";
import { Headline, BodyBig, Body } from "../Typography";

const HeroContacts = ({ text, offices, contacts }) => {
  const { cursorChangeHandler, cursorChangeText } = useContext(MouseContext);

  return (
    <StyledHeroContacts>
      <StyledHeroLogo>
        <svg width="1345" height="1001" viewBox="0 0 1345 1001" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1155.37 93.6629C1259.78 93.6653 1344 178.423 1344 283.902C1343.76 328.47 1322.25 375.204 1302.53 405.117L672.5 1358L672.599 862.151L954.238 435.339C963.885 420.718 953.511 401.136 936.118 401.136H694.434C682.406 401.136 672.656 391.286 672.656 379.135V93.6629H1155.37ZM672.401 93.8348L390.762 520.647C381.115 535.267 391.489 554.85 408.882 554.85H650.58C662.604 554.854 672.357 564.703 672.358 576.85V862.323H189.629C85.2197 862.319 1.00307 777.573 1 672.099C1.23598 627.527 22.7615 580.782 42.4858 550.868L672.5 -402L672.401 93.8348Z" stroke="white" stroke-opacity="0.15" />
        </svg>

      </StyledHeroLogo>

      <StyledContent>
        <StyledTitle>
          <Headline>
            <h1>
              <AnimateSplitFadeIn>{text}</AnimateSplitFadeIn>
            </h1>
          </Headline>
        </StyledTitle>

        <StyledForm
          data-type={contacts.form_type}
          onMouseOver={() => {
            cursorChangeHandler("hide");
            cursorChangeText("");
          }}
          onMouseLeave={() => {
            cursorChangeHandler("");
            cursorChangeText("");
          }}
        >
          <AnimateFadeIn delay={1.5}>
            {contacts.form_type == "typeform" ? (
              <Widget id={contacts.form} className="my-form" />
            ) : (
              <iframe src={contacts.form} />
            )}
          </AnimateFadeIn>
        </StyledForm>

        <StyledOffices>
          <ul>
            {offices.list &&
              offices.list.map((el, i) => {
                return (
                  <li key={i}>
                    <AnimateFadeIn delay={1.5 + i / 10}>
                      <BodyBig>{el.name}</BodyBig>
                      <Body>{el.address}</Body>
                      <Body>{el.cap}</Body>

                      <div style={{ marginTop: "0.8rem" }}>
                        <WrapperLink data={el.cta}>
                          <Cta>{el.cta.label}</Cta>
                        </WrapperLink>
                      </div>
                    </AnimateFadeIn>
                  </li>
                );
              })}
          </ul>
        </StyledOffices>
      </StyledContent>
    </StyledHeroContacts>
  );
};

export default HeroContacts;
